import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

const base = "/api/admin/AdminReminderSubjects";

export const getReminderSubjectListSaga = createAction(
  "GET_REMINDER_SUBJECTS_ADMIN",
  ({ payload, params }: SagaActionParams<Type.ReminderSubjectDto[]>) => ({
    payload,
    url: base + (params ? params : ""),
  })
);
export const getReminderSubjectDetailsSaga = createAction(
  "GET_REMINDER_SUBJECT_DETAILS_ADMIN",
  ({ payload, id }: SagaActionParams<Type.ReminderSubjectDetailDto>) => ({
    payload,
    url: base + "/" + id,
  })
);
export const createReminderSubjectSaga = createAction(
  "CREATE_REMINDER_SUBJECT_ADMIN",
  ({ payload, body }: SagaActionParams<Type.ReminderSubjectDto>) => ({
    payload,
    url: base,
    body,
  })
);
export const updateReminderSubjectSaga = createAction(
  "UPDATE_REMINDER_SUBJECT_ADMIN",
  ({ payload, id, body }: SagaActionParams<Type.ReminderSubjectDto>) => ({
    payload,
    url: base + "/" + id,
    body,
  })
);
export const deleteReminderSubjectSaga = createAction(
  "DELETE_REMINDER_SUBJECT_ADMIN",
  ({ payload, id }: SagaActionParams<Type.ReminderSubjectDto>) => ({
    payload,
    url: base + "/" + id,
  })
);

const reminderSubjectsSaga = [
  takeLatest<any>(
    getReminderSubjectListSaga.toString(),
    (payload: SagaGenericParams<Type.ReminderSubjectDto[]>) =>
      getSaga<Type.ReminderSubjectDto[]>(payload)
  ),
  takeLatest<any>(
    getReminderSubjectDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.ReminderSubjectDetailDto>) =>
      getSaga<Type.ReminderSubjectDetailDto>(payload)
  ),
  takeLatest<any>(
    createReminderSubjectSaga.toString(),
    (payload: SagaGenericParams<Type.ReminderSubjectDto>) =>
      postSaga<Type.ReminderSubjectDto>(payload)
  ),
  takeLatest<any>(
    updateReminderSubjectSaga.toString(),
    (payload: SagaGenericParams<Type.ReminderSubjectDto>) =>
      putSaga<Type.ReminderSubjectDto>(payload)
  ),
  takeLatest<any>(
    deleteReminderSubjectSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.ReminderSubjectDto>(payload)
  ),
];

export default reminderSubjectsSaga;
